import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ServiceRequestCard = ({ request, onViewDetails }) => {
  const getStatusColor = (status) => {
    switch (status) {
      case 'Aberta':
        return 'text-warning bg-warning/10';
      case 'Em Andamento':
        return 'text-primary bg-primary/10';
      case 'Aguardando Cliente':
        return 'text-accent bg-accent/10';
      case 'Resolvida':
        return 'text-success bg-success/10';
      case 'Fechada':
        return 'text-muted-foreground bg-muted';
      default:
        return 'text-muted-foreground bg-muted';
    }
  };

  const getPriorityColor = (priority) => {
    switch (priority) {
      case 'Alta':
        return 'text-error';
      case 'Média':
        return 'text-warning';
      case 'Baixa':
        return 'text-success';
      default:
        return 'text-muted-foreground';
    }
  };

  const getCategoryIcon = (category) => {
    switch (category) {
      case 'Técnico':
        return 'Wrench';
      case 'Suporte':
        return 'HelpCircle';
      case 'Manutenção':
        return 'Settings';
      case 'Instalação':
        return 'Plus';
      default:
        return 'ClipboardList';
    }
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 hover:shadow-professional transition-all duration-200">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-muted rounded-lg flex items-center justify-center">
            <Icon name={getCategoryIcon(request?.category)} size={18} className="text-muted-foreground" />
          </div>
          <div>
            <h4 className="font-medium text-card-foreground">
              #{request?.id} - {request?.title}
            </h4>
            <p className="text-sm text-muted-foreground">
              {request?.category} • Criada em {request?.createdDate}
            </p>
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <span className={`text-xs font-medium ${getPriorityColor(request?.priority)}`}>
            {request?.priority}
          </span>
          <span className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(request?.status)}`}>
            {request?.status}
          </span>
        </div>
      </div>
      <p className="text-sm text-muted-foreground mb-3 line-clamp-2">
        {request?.description}
      </p>
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4 text-xs text-muted-foreground">
          {request?.assignedTo && (
            <div className="flex items-center">
              <Icon name="User" size={14} className="mr-1" />
              <span>{request?.assignedTo}</span>
            </div>
          )}
          {request?.lastUpdate && (
            <div className="flex items-center">
              <Icon name="Clock" size={14} className="mr-1" />
              <span>Atualizada {request?.lastUpdate}</span>
            </div>
          )}
        </div>
        <Button
          variant="ghost"
          size="sm"
          onClick={() => onViewDetails(request)}
          iconName="ExternalLink"
          iconPosition="right"
        >
          Abrir
        </Button>
      </div>
    </div>
  );
};

export default ServiceRequestCard;